import { gql } from "@apollo/client";
import { ReportData } from "../../../../Definitions";

export const REPORT_FILTER_FRAGMENT = gql`
  fragment FilterFields on Filter {
    key
    value {
      id
      label
    }
  }
`

export const REPORT_FRAGMENT = gql`
  fragment ReportFields on Report {
    name
    reportId: report_id
    deleted
    startDate: start_date
    endDate: end_date
    data(domain: $domain) @include(if: $ifFetchData) {
      __typename
      ... on FeedReportAnimalData {
        system
        system_id
        animal_id
        location
        location_id
        section_id
        section
        feedcurve_id
        animal_number
        cycle
        correction
        feedcurve_milestones
        milestone_day
        condition
        animal_type
        responder_number
        life_number
        birthday
        animal_group_name
        milestone_name
        milestone_id
        animal_group_id
        consumption {
          expected_amount
          accumulated_amount
          timestamp
        }
      }
      ... on FeedReportGroupData {
        group_id
        group_name
        consumption {
          expected_amount
          accumulated_amount
          timestamp
        }
      }
      ... on FeedReportSystemData {
        system_id_for_report
        system_name
        consumption {
          expected_amount
          accumulated_amount
          timestamp
        }
      }
    }
    
    created 
    archived
    filterParameter: filter {
      ...FilterFields
      }
    dataLevel: data_level
  }
${REPORT_FILTER_FRAGMENT}
`

export const GET_ARCHIVED_REPORTS = gql`
  query Reports($domain: String!, $input: BasicQueryInfoInput!, $ifFetchData: Boolean!) {
    report {
      archived(domain: $domain, input: $input) {
        ...ReportFields 
      }
    }
  }
  ${REPORT_FRAGMENT}
`

 
export interface ArchivedReportResponse {
  report: {
    archived: ReportData[]
  }
}

interface ReportConsumption {
  expected_amount: number;
  accumulated_amount: number;
  timestamp: number;
}
interface ReportConsumptionData {
  consumption: [ReportConsumption | null]
}

export interface ReportWithData {
  report: {
    archived:     
      (ReportData & {data?: (FeedReportAnimalData | FeedReportGroupData | FeedReportSystemData)[]})[]
  }
}

export interface FeedReportSystemData extends ReportConsumptionData {
  system_name: string;
  system_id_for_report: number;
}

export interface FeedReportGroupData extends ReportConsumptionData {
  group_id: number;
  group_name: string;
}

// TODO cto check overlap with animal info
export interface FeedReportAnimalData extends ReportConsumptionData {
  system?: string;
  system_id?: number;
  animal_id: number | JSX.Element;
  location?: string;
  location_id?: number;
  section_id?: number;
  section?: string;
  feedcurve_id?: number;
  animal_number: number;
  cycle?: number;
  correction?: number;
  feedcurve_milestones?: number;
  milestone_day?: number | string;
  condition?: number;
  animal_type?: number;
  responder_number?: string;
  life_number?: number;
  birthday?: number | string;
  animal_group_name?: string;
  milestone_name?: string;
  milestone_id?: number;
  animal_group_id?: number;
}